import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ThumbsUp5Fill = function ThumbsUp5Fill(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M21.9663 11.2273C21.9556 10.0802 20.903 9.14989 19.6102 9.14989H15.7026L16.4599 6.64998C16.7428 5.71601 16.1655 4.63409 15.1737 4.23858L14.975 4.15905C14.7108 4.05363 14.4306 4 14.1415 4C13.3358 4 12.601 4.41877 12.2813 5.04414C11.056 7.09807 9 10.6358 9 11.2448V17.9051C9 19.0602 10.0568 20 11.3561 20H17.5194C17.5655 20 17.6115 19.9942 17.6555 19.982C19.0825 19.5989 21.3816 14.5146 21.9524 12.4614C22.0373 12.156 21.9868 11.4593 21.9663 11.2273Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M7 19.5322V9.4675C7 9.20942 6.79044 9 6.53188 9H2.46812C2.20986 9 2 9.20942 2 9.4675V19.5322C2 19.7906 2.20956 20 2.46812 20H6.53217C6.79044 20 7 19.7906 7 19.5322Z",
      fill: !ignoreColor ? color : undefined
    })]
  });
};
export default ThumbsUp5Fill;